export default __webpack_public_path__ + "static/media/logo-Swiss-Beauty.3f882361.svg";